import { PollSlideTypes } from '../../../../../db/types';
import ClassesForm from '../../../../shared/TileClassesForm';
import CoursesForm from '../../../../shared/TileCoursesForm';
import PollsForm from '../../PollsForm';
import Introduction from '../Introduction';
import usePieChartSteps, { UsePieChartSteps } from './vm';

export enum Steps {
  INTRODUCTION,
  COURSE_SELECTION,
  CLASS_SELECTION,
  POLL_SELECTION,
}

export interface StepsProps extends UsePieChartSteps {
  currentStep: Steps;
}

const PieChartSteps = ({ currentStep, ...vmProps }: StepsProps) => {
  const { goToNextStep } = vmProps;
  const {
    selectedCourse,
    selectedClass,
    handleClickIntroductionNext,
    handleClickCourseSelectionNext,
    handleClickClassSelectionNext,
    handleClickPollSelectionNext,
  } = usePieChartSteps(vmProps);

  switch (currentStep) {
    case Steps.INTRODUCTION:
      return <Introduction onNext={handleClickIntroductionNext} goToNextStep={goToNextStep} />;
    case Steps.COURSE_SELECTION:
      return <CoursesForm onNext={handleClickCourseSelectionNext} />;
    case Steps.CLASS_SELECTION:
      return <ClassesForm selectedCourse={selectedCourse!} onNext={handleClickClassSelectionNext} />;
    case Steps.POLL_SELECTION:
      return (
        <PollsForm
          selectedCourse={selectedCourse!}
          selectedClass={selectedClass!}
          slideType={PollSlideTypes.PIE_CHART}
          onNext={handleClickPollSelectionNext}
        />
      );
    default:
      return null;
  }
};

export default PieChartSteps;
